var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRainmakerSoftIcon09Delete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "current",
    viewBox: "0 0 33.1 33.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1 7.6h-6.3V5c0-1.1-.9-2-2-2h-4.4c-1.1 0-2 .9-2 2v2.7H6.1c-.4-.1-.8.3-.8.7 0 .4.3.8.8.8h1v17.5c0 1.7 1.4 3 3 3h13.1c1.7 0 3-1.4 3-3V9.1h1c.4 0 .8-.3.8-.8-.1-.3-.5-.7-.9-.7zM13.9 5c0-.3.2-.5.5-.5h4.4c.3 0 .5.2.5.5v2.7H14V5zm10.8 21.6c0 .8-.7 1.5-1.5 1.5H10.1c-.8 0-1.5-.7-1.5-1.5V9.1h16.1v17.5zm-4.4-1.7V12.4c0-.4.3-.8.8-.8s.8.3.8.8V25c0 .4-.3.8-.8.8s-.8-.5-.8-.9zm-4.4 0V12.4c0-.4.3-.8.7-.8s.8.3.8.8V25c0 .4-.3.8-.8.8s-.7-.5-.7-.9zm-4.4 0V12.4c0-.4.3-.8.8-.8s.8.3.8.8V25c0 .4-.3.8-.8.8s-.8-.5-.8-.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainmakerSoftIcon09Delete);
export default __webpack_public_path__ + "static/media/Rainmaker_soft_icon_09_Delete.d01aab69.svg";
export { ForwardRef as ReactComponent };